<template>
  <div>
    <div v-if="(jobStatus && jobStatus.status === 'in-progress') && (jobInProgress && jobInProgress.status === 'in-progress')">
      <el-alert
        style="margin-bottom: 10px;"
        :closable="false"
      >
        <div style="margin-left: -10px; margin-bottom: 3px">
          <i class="el-icon-loading"></i> Képviselői árlista módosítása folyamatban van.
        </div>
      </el-alert>
      <el-progress
        style="margin-bottom: 20px;"
        :text-inside="true"
        :stroke-width="20"
        :percentage="jobInProgress.percent"
      />
    </div>
    <el-card>
      <div
        slot="header"
        class="clearfix"
      >
        <span>Alapértelmezett képviselői árak</span>
        <el-button
          v-can="['representativeprice.update']"
          :disabled="(jobStatus && jobStatus.status === 'in-progress') && (jobInProgress && jobInProgress.status === 'in-progress')"
          :loading="buttonLoading"
          style="float: right; margin-top: -5px;"
          type="primary"
          size="small"
          icon="el-icon-edit"
          @click="storePrices"
        >
          Árak mentése
        </el-button>
        <el-button
          @click="download"
          size="small"
          style="float: right; margin-top: -5px; margin-right: 10px;"
        >Excel letöltés</el-button>
      </div>
      <div v-loading="filterLoading" style="display: flex; justify-content: space-between; margin: -20px -20px 30px -20px; padding: 20px; border-bottom: 1px solid #EBEEF5;">
        <table-filter
          v-if="filterConfig"
          :config="filterConfig"
          action="representativePrice/fetchAll"
          style="border-bottom: 0; margin: 0; padding: 0"
        />
        <el-button
          type="primary"
          plain
          @click="reCalculate"
        >
          Összes ár újraszámolása
        </el-button>
      </div>
      <representative-price-list
        ref="list"
      />
    </el-card>
  </div>
</template>

<script>
import RepresentativePriceList from '../../components/representativeProcesses/representativePrices/List';
import TableFilter from '../../components/TableFilter';
import { saveAs } from 'file-saver';


export default {
  components: {
    RepresentativePriceList,
    TableFilter,
  },
  data() {
    return {
      loading: false,
      jobInProgress: null,
      filterConfig: null,
      buttonLoading: false,
      filterLoading: false,
    };
  },
  computed: {
    jobStatus() {
      return this.$store.getters['job/jobs'].find(j => j.name === 'update_representative_prices');
    },
  },
  async mounted() {
    Echo.channel('representativePrices')
      .listen('.status', (data) => {
        this.jobInProgress = data;
      });
    await this.$store.dispatch('job/fetchAll');
    this.filterLoading = true;
    await this.setConfig();
    this.filterLoading = false;
  },
  methods: {
    async storePrices() {
      this.buttonLoading = true;
      try {
        const priceTypes = this.$refs['list'].priceTypes;
        const prices = this.$refs['list'].getItems();
        await this.$store.dispatch('representativePrice/update', { prices, priceTypes });
      } catch (e) {

      }
      await this.$store.dispatch('job/fetchAll');
      this.buttonLoading = false;
    },
    async setConfig() {
      let productCategories = this.$store.getters['productCategory/productCategories'];
      if(!productCategories.length) {
        await this.$store.dispatch('productCategory/fetchAll');
        productCategories = this.$store.getters['productCategory/productCategories'];
      }
      this.filterConfig = [
        {
          type: 'text',
          name: 'name',
          label: 'Név',
          defaultSearch: true,
        },
        {
          type: 'select',
          name: 'category_id',
          label: 'Kategória',
          options: productCategories,
          labelCallback: category => category && `${category.name}` || '',
          valueKey: 'id',
        },
      ]
    },
    reCalculate() {
      this.$refs['list'].reCalculate();
    },

    async download() {
      try {
        const excel = await axios({
          url: `api/product-representative-prices/export`,
          method: 'POST',
          responseType: 'blob',
        });
        console.log(excel)
        saveAs(excel, `representativeprices.xlsx`);
      } catch (e) {}
    },
  },
};
</script>
